import React from "react";
import { Link, useParams } from "react-router";
import { FiArrowRight } from "react-icons/fi";
import { useCourse } from "../context/CourseContext";
import GroupFeed from "./feed/GroupFeed";

const CourseDetails = () => {
  const { course } = useCourse();
  const { slug } = useParams();
  return (
    <main className="mx-auto grid max-w-7xl gap-6 px-4 py-8 sm:px-8 lg:grid-cols-[180px_minmax(0,640px)_220px]">
      <section className="contents" aria-label="Group feed">
        <GroupFeed key={course._id} groupId={course._id} />
      </section>
      <aside className="min-w-0 border-t border-gray-200 pt-6 lg:border-l lg:border-t-0 lg:pl-8 lg:pt-0">
        <h2 className="text-sm font-semibold">About this group</h2>
        <p className="mt-3 whitespace-pre-wrap break-words text-sm font-medium leading-6 text-gray-700">{course?.description || "No description yet."}</p>
        <div className="mt-6 space-y-4 border-t border-gray-200 pt-6">
          <Link to={`/courses/${slug}/classes`} className="flex items-center justify-between text-sm font-medium text-gray-700 hover:text-orange-700">Classes<FiArrowRight aria-hidden="true" /></Link>
          <Link to={`/courses/${slug}/learners`} className="flex items-center justify-between text-sm font-medium text-gray-700 hover:text-orange-700">Members<FiArrowRight aria-hidden="true" /></Link>
        </div>
      </aside>
    </main>
  );
};
export default CourseDetails;
